import locale from "@bonliva-crm/locale";
import {
  BookingKitStatusType,
  AccommodationRequestStatusType
} from "@bonliva-crm/shared";

//TODO refactor filter-records to use this file and remove code duplication

export const bookingKitStatusOptions = [
  BookingKitStatusType.SentToHBA,
  BookingKitStatusType.RejectedByHBA,
  BookingKitStatusType.SentToOC,
  BookingKitStatusType.RejectedByOC,
  BookingKitStatusType.SentToFinancePayment,
  BookingKitStatusType.RejectedByFinancePayment,
  BookingKitStatusType.SentToFinanceInvoicing,
  BookingKitStatusType.RejectedByFinanceInvoicing,
  BookingKitStatusType.Done,
  BookingKitStatusType.Deleted
].map((status) => ({
  label: locale.bookingKitStatusType[status],
  value: status
}));

export const accommodationRequestStatusOptions = Object.values(
  AccommodationRequestStatusType
).map((status) => ({
  label: locale.accommodationRequestStatusType[status],
  value: status
}));

export const travelRequestStatusOptions = Object.values(
  AccommodationRequestStatusType
).map((status) => ({
  label: locale.travelRequestStatusType[status],
  value: status
}));
